import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { StepRunHistory } from '@/types/stepExecutions.ts';
import { STEP_RUN_HISTORY_KEY } from '@/utils/queryKeys.ts';
import { get_run_step_history_url } from '@/utils/urls.ts';

const useRetrieveStepRunHistory = ({
  runId,
  stepId,
  fullPath,
  stepRunId,
  enabled = true,
}: {
  runId?: string;
  stepId?: string;
  fullPath?: string | null;
  stepRunId?: string;
  enabled?: boolean;
}): UseQueryResult<StepRunHistory, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STEP_RUN_HISTORY_KEY(automationId, runId, stepId, fullPath, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get<StepRunHistory>(
        get_run_step_history_url({ runId, stepId, fullPath, stepRunId }),
      );
      return response.data;
    },
    enabled: !!runId && !!stepId && !!fullPath && enabled,
  });
};

export default useRetrieveStepRunHistory;
